<template>
  <div class="player-career">
    <div class="header">
      <div class="img">
        <img v-if="player.profile" :src="profileImg">
      </div>
      <div class="jerseyNo">{{player.jerseyNo}}</div>
    </div>
    <div class="haha">
      <div class="info">
        <span class="name">{{player.trueName}}</span>
      </div>
      <div class="info">
        <span class="base">
          {{player.position}}&nbsp;&nbsp;
          |&nbsp;&nbsp;{{player.high}}cm&nbsp;&nbsp;
          |&nbsp;&nbsp;{{player.weight}}kg&nbsp;&nbsp;
          |&nbsp;&nbsp;{{getAge(player.birthday)}}岁
        </span>
      </div>
      <div class="info">
        <span class="org">{{player.organizationName}}</span>
      </div>
    </div>
<!--    <div class="line"></div>-->
    <div class="current-year">
      <div class="top">{{currentYearData.year}}年度统计</div>
      <div class="row">
        <div class="item">
          <div class="name">场次</div>
          <div class="number">{{ currentYearData.gameCount }}</div>
        </div>
        <div class="one">
          <div class="first"></div>
          <div class="second"></div>
        </div>
        <div class="item">
          <div class="name">胜场</div>
          <div class="number">{{ currentYearData.win }}</div>
        </div>
        <div class="one">
          <div class="first"></div>
          <div class="second"></div>
        </div>
        <div class="item">
          <div class="name">进球</div>
          <div class="number">{{ currentYearData.goalCount }}</div>
        </div>
      </div>
      <div class="border-line">
        <div class="tow">
          <div class="first"></div>
          <div class="second"></div>
        </div>
        <div class="three">
          <div class="first"></div>
          <div class="second"></div>
        </div>
        <div class="four">
          <div class="first"></div>
          <div class="second"></div>
        </div>
      </div>
      <div class="row">
        <div class="item">
          <div class="name">助攻</div>
          <div class="number">{{ currentYearData.assistCount }}</div>
        </div>
        <div class="five">
          <div class="first"></div>
          <div class="second"></div>
        </div>
        <div class="item">
          <div class="name">射门</div>
          <div class="number">{{ currentYearData.anyShootCount }}</div>
        </div>
        <div class="five">
          <div class="first"></div>
          <div class="second"></div>
        </div>
        <div class="item">
          <div class="name">罚时<span style="font-size: 12px; zoom: 0.8">(min)</span></div>
          <div class="number">{{ currentYearData.penaltyCount }}</div>
        </div>
      </div>
      <div class="border-line">
        <div class="tow">
          <div class="first"></div>
          <div class="second"></div>
        </div>
        <div class="three">
          <div class="first"></div>
          <div class="second"></div>
        </div>
        <div class="four">
          <div class="first"></div>
          <div class="second"></div>
        </div>
      </div>
      <div class="row">
        <div class="item">
          <div class="name">EQ</div>
          <div class="number">{{ currentYearData.eqCount }}</div>
        </div>
        <div class="six">
          <div class="first"></div>
          <div class="second"></div>
        </div>
        <div class="item">
          <div class="name">EN</div>
          <div class="number">{{ currentYearData.enCount }}</div>
        </div>
        <div class="six">
          <div class="first"></div>
          <div class="second"></div>
        </div>
        <div class="item">
          <div class="name">+/-</div>
          <div class="number"><span v-if="currentYearData.plusMinus > 0">+</span>{{ currentYearData.plusMinus }}</div>
        </div>
      </div>
    </div>
    <div class="title" v-if="teamExperienceList.length > 0">北京青少年队入选经历</div>
    <div class="team-join">
      <ul>
        <li v-for="(item, index) in teamExperienceList" :key="index">{{item.year}}年&nbsp;&nbsp;&nbsp;{{item.name}}</li>
      </ul>
    </div>
    <div class="title">年度统计</div>
    <div class="year-list">
      <div class="left-table">
        <table>
          <tr>
            <td class="head">年度</td>
          </tr>
          <tr v-for="(item, index) in leftColumn" :key="index">
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item}}<span v-if="index>0">年</span></td>
          </tr>
        </table>
      </div>
      <div class="right-table">
        <table>
          <tr>
            <td class="head">场次</td>
            <td class="head">主队胜场</td>
            <td class="head">客队胜场</td>
            <td class="head">进球</td>
            <td class="head">助攻</td>
            <td class="head">点球进球</td>
            <td class="head">点球制胜球</td>
            <td class="head">加时（min）</td>
            <td class="head">加时进球</td>
            <td class="head">罚时（min）</td>
            <td class="head">射门</td>
            <td class="head">EQ</td>
            <td class="head">EN</td>
            <td class="head">+1</td>
            <td class="head">+2</td>
            <td class="head">-1</td>
            <td class="head">-2</td>
            <td class="head">PS</td>
            <td class="head">GWG</td>
            <td class="head">守丢球</td>
            <td class="head">守住球</td>
            <td class="head">守丢致输</td>
            <td class="head">MVP</td>
          </tr>
          <tr v-for="(item, index) in years" :key="index" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.gameCount}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.homeWin}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.awayWin}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.goalCount}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.assistCount}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.shootoutCount}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.shootoutWinCount}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.plusCount}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.plusGoalCount}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.penaltyCount}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.anyShootCount}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.eqCount}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.enCount}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.p1Count}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.p2Count}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.m1Count}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.m2Count}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.psCount}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.gwgCount}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.keepLoseCount}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.keepCount}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.keepLoseWinCount}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.mvp}}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="title">
      <span>赛事统计</span>
    </div>
    <div class="march-list">
      <div class="left-table">
        <table>
          <tr>
            <td class="head">赛事</td>
          </tr>
          <tr v-for="(item, index) in matchNames" :key="index">
            <td class="info" style="width: 100%;" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">
              <span class="info name" style="height: 50px;">{{item}}</span>
            </td>
          </tr>
        </table>
      </div>
      <div class="right-table">
        <table>
          <tr>
            <td class="head">场次</td>
            <td class="head">主队胜场</td>
            <td class="head">客队胜场</td>
            <td class="head">进球</td>
            <td class="head">助攻</td>
            <td class="head">点球进球</td>
            <td class="head">点球制胜球</td>
            <td class="head">加时（min）</td>
            <td class="head">加时进球</td>
            <td class="head">罚时（min）</td>
            <td class="head">射门</td>
            <td class="head">EQ</td>
            <td class="head">EN</td>
            <td class="head">+1</td>
            <td class="head">+2</td>
            <td class="head">-1</td>
            <td class="head">-2</td>
            <td class="head">PS</td>
            <td class="head">GWG</td>
            <td class="head">守丢球</td>
            <td class="head">守住球</td>
            <td class="head">守丢致输</td>
            <td class="head">MVP</td>
          </tr>
          <tr v-for="(item, index) in matchList" :key="index" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.gameCount}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.homeWin}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.awayWin}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.goal}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.assist}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.shootoutGoal}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.shootoutWin}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.plusCount}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.plusGoalCount}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.penaltyMinute}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.anyShoot}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.eq}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.en}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.p1}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.p2}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.m1}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.m2}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.ps}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.gwg}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.keepLose}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.keep}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.shootoutLose}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.mvp}}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="title">球队统计</div>
    <div class="team-list">
      <div class="left-table">
        <table>
          <tr>
            <td class="head">球队</td>
          </tr>
          <tr v-for="(item, index) in teamNames" :key="index">
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">
              <span class="info">{{item}}</span>
            </td>
          </tr>
        </table>
      </div>
      <div class="right-table">
        <table>
          <tr>
            <td class="head">场次</td>
            <td class="head">主队胜场</td>
            <td class="head">客队胜场</td>
            <td class="head">进球</td>
            <td class="head">助攻</td>
            <td class="head">点球进球</td>
            <td class="head">点球制胜球</td>
            <td class="head">加时（min）</td>
            <td class="head">加时进球</td>
            <td class="head">罚时（min）</td>
            <td class="head">射门</td>
            <td class="head">EQ</td>
            <td class="head">EN</td>
            <td class="head">+1</td>
            <td class="head">+2</td>
            <td class="head">-1</td>
            <td class="head">-2</td>
            <td class="head">PS</td>
            <td class="head">GWG</td>
            <td class="head">守丢球</td>
            <td class="head">守住球</td>
            <td class="head">守丢致输</td>
            <td class="head">MVP</td>
          </tr>
          <tr v-for="(item, index) in teamList" :key="index" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.gameCount}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.homeWin}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.awayWin}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.goal}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.assist}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.shootoutGoal}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.shootoutWin}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.plusCount}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.plusGoalCount}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.penaltyMinute}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.shootoutGoal}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.eq}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.en}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.p1}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.p2}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.m1}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.m2}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.ps}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.gwg}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.keepLose}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.keep}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.shootoutLose}}</td>
            <td class="info" :class="index%2 === 1 ? 'bgc1' : 'bgc2'">{{item.mvp}}</td>
          </tr>
        </table>
      </div>
    </div>
    <div style="width: 100%; height: 70px;"></div>
    <div class="export" @click="exportPDF">
      <span>导出个人运动数据PDF版》</span>
    </div>
    <van-popup v-model="show" position="bottom">
      <van-picker
        show-toolbar
        title="导出PDF"
        :columns="columns"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { getPlayerIceHockeyCareer, personalHockeyDataExportPDF } from '@/api/user'
import { ImageFormat } from '@/utils'
import { getMyPlayer } from '@/api/info'

import Vue from 'vue'
import { Toast, Popup, Picker,Dialog } from 'vant'

Vue.use(Toast).use(Picker).use(Popup).use(Dialog)

export default {
  name: 'player-career',
  data() {
    return {
      selectYear: '',
      columns: [],
      show: false,
      year: '',
      playerId: '',
      matchId: '',
      teamId: '',
      player: {},
      currentYearData: {},
      years: [],
      leftColumn: [],
      teamExperienceList: [],
      matchList: [],
      matchNames: [],
      matchOptions: [],
      teamList: [],
      teamNames: [],
      teamOptions: []
    }
  },
  mounted() {
    this.getMyPlayer()
    this.year = new Date().getFullYear()
    this.columns.push('历年')
    for (let i = 0; i < 10; i++) {
      this.columns.push(this.year - i)
    }
  },
  computed: {
    profileImg() {
      return ImageFormat.squareImageView(this.player.profile, 200, 1)
    }
  },
  methods: {
    onConfirm(value, index) {
      if (value !== '历年') this.selectYear = value
      else this.selectYear = ''
      this.exportPDF()
    },
    onCancel() {
      this.show = false
    },
    showPopup() {
      this.show = true
    },
    getMyPlayer() {
      getMyPlayer().then(response => {
        const data = response.data
        if (data) {
          this.playerId = data.player.id
          this.getPlayerYearsList()
        }
      })
    },
    exportPDF() {
      Dialog.confirm({
        title: '导出PDF',
        message: '是否确认导出个人数据PDF',
      }).then(() => {
        const params = {
          playerId: this.playerId
          // year: this.selectYear
        }
        personalHockeyDataExportPDF(params).then(res => {
          if (res) {
            this.show = false
            Toast.success('请查看邮箱')
          }
        })
      })
    },
    selectMatch(item) {
      this.matchId = item.value
      console.log(this.matchId)
    },
    getPlayerYearsList() {
      const params = {
        playerId: this.playerId,
        matchId: this.matchId,
        teamId: this.teamId
      }
      getPlayerIceHockeyCareer(params).then(res => {
        console.log(res.data)
        const { data } = res
        this.player = data.player
        this.currentYearData = data.currentYearData
        this.teamExperienceList = data.teamExperienceList
        this.years = data.years
        this.years.forEach(item => {
          this.leftColumn.push(item.year)
        })
        this.matchList = data.matchList
        this.matchList.forEach(item => {
          this.matchNames.push(item.matchName)
          this.matchOptions.push({ text: item.matchName, value: item.id })
        })
        this.teamList = data.teamList
        this.teamList.forEach(item => {
          this.teamNames.push(item.teamName)
          this.teamOptions.push({ text: item.teamName, value: item.id })
        })
      })
    },
    getAge(date) {
      const currentYear = new Date().getFullYear()
      const birthYear = new Date(date).getFullYear()
      return currentYear - birthYear + 1
    }
  }
}
</script>

<style lang="scss" scoped>
.player-career {
  .line {
    width: 100%;
    border-bottom: 1px #E4E4E4 solid;
  }
  .title {
    margin: 28px 0 14px 10px;
    border-left: 3px #10255B solid;
    padding-left: 20px;
    color: #10255B;
    font-size: 16px;
    font-weight: bolder;
    line-height: 20px;
    .option {
      margin-right: 10px;
      float: right;
    }
  }
  .header {
    height: 120px;
    background-image: url("http://image.bjh.snsports.cn/Fk8eFgL4eZZPAePD0o8IhegrL3u0?imageView2/1/w/750/h/240");
    background-size: 100% 100%;
    position: relative;
    .img {
      position: absolute;
      width: 100%;
      top: 50px;
      text-align: center;
      img {
        width: 90px;
        height: 90px;
        border-radius: 55px;
        border: 4px black solid;
      }
    }
    .jerseyNo {
      width: 37px;
      height: 37px;
      position: absolute;
      background-color: #10255B;
      color: #FFFFFF;
      border-radius: 50%;
      line-height: 34px;
      text-align: center;
      font-size: 24px;
      font-weight: 500;
      top: 107px;
      left: 218px
    }
  }
  .haha {
    margin-top: 32px;
    .info {
      text-align: center;
      margin-bottom: 5px;
      .name {
        font-weight: bolder;
        font-size: 22px;
      }
      .base {
        font-size: 16px;
      }
      .org {
        font-size: 20px;
        font-weight: 500;
        color: #E55728;
      }
    }
  }
  .current-year {
    margin-top: 20px;
    .top {
      text-align: center;
      font-size: 16px;
      margin-bottom: 10px;
    }
    .border-line {
      background: #F7F8FB;
      margin: 0 13px;
      display: flex;
      flex-flow: row;
      .tow  {
        width: 117px;
        height: 3px;
        display: flex;
        flex-flow: row;
        .first {
          height: 3px;
          width: 59px;
        }
        .second {
          width: 59px;
          height: 3px;
          background-image: linear-gradient(to right, rgba(239, 239, 239, 0), rgba(239, 239, 239,1));
        }
      }
      .three  {
        width: 117px;
        height: 3px;
        display: flex;
        flex-flow: row;
        .first {
          height: 3px;
          width: 59px;
          background-image: linear-gradient(to left, rgba(239, 239, 239, 0), rgba(239, 239, 239,1));
        }
        .second {
          width: 59px;
          height: 3px;
          background-image: linear-gradient(to right, rgba(239, 239, 239, 0), rgba(239, 239, 239,1));
        }
      }
      .four  {
        width: 117px;
        height: 3px;
        display: flex;
        flex-flow: row;
        .first {
          height: 3px;
          width: 59px;
          background-image: linear-gradient(to left, rgba(239, 239, 239, 0), rgba(239, 239, 239,1));
        }
        .second {
          width: 59px;
          height: 3px;
        }
      }
    }
    .row {
      border-radius: 6px 0px 0px 0px;
      background: #F7F8FB;
      margin: 0 13px;
      display: flex;
      justify-content: space-around;
      .one {
        width: 3px;
        height: 117px;
        display: flex;
        flex-flow: column;
        .first {
          height: 59px;
          width: 3px;
        }
        .second {
          width: 3px;
          height: 59px;
          background-image: linear-gradient(to bottom, rgba(239, 239, 239, 0), rgba(239, 239, 239,1));
        }
      }
      .five {
        width: 3px;
        height: 117px;
        display: flex;
        flex-flow: column;
        .first {
          height: 59px;
          width: 3px;
          background-image: linear-gradient(to top, rgba(239, 239, 239, 0), rgba(239, 239, 239,1));
        }
        .second {
          width: 3px;
          height: 59px;
          background-image: linear-gradient(to bottom, rgba(239, 239, 239, 0), rgba(239, 239, 239,1));
        }
      }
      .six {
        width: 3px;
        height: 117px;
        display: flex;
        flex-flow: column;
        .first {
          height: 59px;
          width: 3px;
          background-image: linear-gradient(to top, rgba(239, 239, 239, 0), rgba(239, 239, 239,1));
        }
        .second {
          width: 3px;
          height: 59px;
        }
      }
      .item {
        width: 117px;
        height: 117px;
        text-align: center;
        padding: 19px 0 18px 0;
        box-sizing: border-box;
        .name {
          color: #666666;
          font-size: 16px;
        }
        .number {
          font-size: 48px;
          font-weight: 500;
          color: #E55728;
        }
      }
    }
  }
  .team-join {
    border-radius: 5px 0 0 5px;
    margin-left: 10px;
    padding-left: 23px;
    background: #F7F8FB;
    ul {
      padding: 8px 0;
      li {
        font-size: 16px;
        padding: 8px 0;
      }
    }
  }
  .year-list {
    margin-left: 10px;
    overflow: hidden;
    .left-table {
      width: 80px;
      float: left;
      table {
        width: 80px;
        border-collapse:collapse;
        border-spacing: 0;
        tr {
          border-bottom: 1px #E9E9E9 solid;
          .head {
            height: 40px;
            line-height: 40px;
            font-size: 15px;
            text-align: center;
            color: #FFFFFF;
            background-color: #E55728;
            margin: 0;
          }
          .info {
            text-align: center;
            font-size: 13px;
            height: 30px;
            line-height: 25px;
            border: none;
          }
          .bgc1 {
            background-color: #F7F7F7;
          }
          .bgc2 {
            background-color: #E4E4E4;
          }
        }
      }
    }
    .right-table {
      width: calc(100vw - 90px);
      float: left;
      overflow: scroll;
      table {
        width: 1760px;
        border-collapse:collapse;
        border-spacing: 0;
        table-layout: fixed;
        word-break: break-all;
        tr {
          border-bottom: 1px #E9E9E9 solid;
          .head {
            height: 40px;
            line-height: 40px;
            font-size: 13px;
            text-align: center;
            color: #FFFFFF;
            background-color: #E55728;
          }
          .info {
            text-align: center;
            height: 30px;
            line-height: 30px;
            font-size: 13px;
            border: none;
          }
          .bgc1 {
            background-color: #ffffff;
          }
          .bgc2 {
            background-color: #F7F7F7;
          }
        }
      }
    }
  }
  .march-list {
    margin-left: 10px;
    overflow: hidden;
    .left-table {
      width: 160px;
      float: left;
      table {
        width: 160px;
        border-collapse:collapse;
        border-spacing: 0;
        table-layout: fixed;
        word-break: break-all;
        tr {
          border-bottom: 1px #E9E9E9 solid;
          .head {
            height: 40px;
            line-height: 40px;
            font-size: 15px;
            text-align: center;
            color: #FFFFFF;
            width: 100%;
            background-color: #E55728;
            margin: 0;
          }
          .info {
            display: inline-block;
            overflow: hidden;
            font-size: 12px;
            height: 44px;
            line-height: 1.5;
            text-align: left;
            border: none;
          }
          .name {
            padding-left: 2px;
            padding-right: 2px;
            position: relative;
            top: 6px;
          }
          .bgc1 {
            background-color: #F7F7F7;
          }
          .bgc2 {
            background-color: #E4E4E4;
          }
        }
      }
    }
    .right-table {
      width: calc(100vw - 170px);
      float: left;
      overflow: scroll;
      table {
        width: 1760px;
        border-collapse:collapse;
        border-spacing: 0;
        table-layout: fixed;
        word-break: break-all;
        tr {
          border-bottom: 1px #E9E9E9 solid;
          .head {
            height: 40px;
            line-height: 40px;
            font-size: 13px;
            text-align: center;
            color: #FFFFFF;
            background-color: #E55728;
          }
          .info {
            text-align: center;
            height: 44px;
            line-height: 1;
            font-size: 14px;
            border: none;
          }
          .bgc1 {
            background-color: #ffffff;
          }
          .bgc2 {
            background-color: #F7F7F7;
          }
        }
      }
    }
  }
  .team-list {
    margin-left: 10px;
    overflow: hidden;
    .left-table {
      width: 120px;
      float: left;
      table {
        width: 120px;
        border-collapse:collapse;
        border-spacing: 0;
        table-layout: fixed;
        word-break: break-all;
        tr {
          border-bottom: 1px #E9E9E9 solid;
          .head {
            height: 40px;
            line-height: 40px;
            font-size: 15px;
            text-align: center;
            color: #FFFFFF;
            background-color: #E55728;
            margin: 0;
          }
          .info {
            height: 30px;
            width: 100%;
            display: inline-block;
            overflow: hidden;
            word-break: break-all;
            text-align: center;
            font-size: 10px;
            line-height: 30px;
            border: none;
          }
          .bgc1 {
            background-color: #F7F7F7;
          }
          .bgc2 {
            background-color: #E4E4E4;
          }
        }
      }
    }
    .right-table {
      width: calc(100vw - 130px);
      float: left;
      overflow: scroll;
      table {
        width: 1760px;
        border-collapse:collapse;
        border-spacing: 0;
        table-layout: fixed;
        word-break: break-all;
        tr {
          border-bottom: 1px #E9E9E9 solid;
          .head {
            height: 40px;
            line-height: 40px;
            font-size: 13px;
            text-align: center;
            color: #FFFFFF;
            background-color: #E55728;
          }
          .info {
            text-align: center;
            height: 30px;
            line-height: 30px;
            font-size: 13px;
          }
          .bgc1 {
            background-color: #ffffff;
          }
          .bgc2 {
            background-color: #F7F7F7;
          }
        }
      }
    }
  }
  .export {
    width: 100%;
    height: 50px;
    position: fixed;
    bottom: 0;
    background-color: #E7E7E7;
    text-align: center;
    line-height: 50px;
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ucenter/player-career.vue